// CORE-108 — Social sign-in client identifiers (all public, safe to ship).
// The matching secrets live only on the backend (GitLab CI variables).
//
// Google: a distinct OAuth client id per platform. The backend accepts any of
// them as a valid id_token audience (Auth:Google:ClientId + ClientIds).
export const GOOGLE_WEB_CLIENT_ID = '1019030401155-d1gio330cod7648ea96vr55d831vt5ld.apps.googleusercontent.com';
// CORE — iOS OAuth client for bundle id com.agapeawesomeapp.agapella (project
// number 1019030401155). Replaces the old …agape client (…k4fb6l4…).
export const GOOGLE_IOS_CLIENT_ID = '1019030401155-ocao1ap8o9tf1g51hphn98p3jk8p8vkt.apps.googleusercontent.com';
export const GOOGLE_ANDROID_CLIENT_ID = '1019030401155-744jt7jimg0k47o3e932lm0g7hc3tf82.apps.googleusercontent.com';

// CORE-1574 — the Google/Apple row is switched off on web (login and register)
// for every region. The native app is not affected: iOS keeps «Войти через
// Apple» (AppleSignInButton, CORE-1581), which needs the provider to stay
// enabled on the backend — so the switch lives here, not in /api/auth/providers.
export const WEB_SOCIAL_AUTH_ENABLED: boolean = false;

// Apple: the web "Services ID" (used as the id_token audience for the web JS
// flow). Native iOS uses the app bundle id instead — handled by the native SDK.
export const APPLE_WEB_SERVICES_ID = 'com.agapeawesomeapp.agapeweb';

/**
 * Google's OAuth for installed apps accepts ONLY the reversed-client-id custom
 * scheme as redirect (`com.googleusercontent.apps.<id>:/…`) — a package-name
 * scheme is rejected with `400: invalid_request`, which is exactly what
 * expo-auth-session v7 generates by default (`<applicationId>:/oauthredirect`).
 * Both reversed schemes are registered in app.json `scheme` so the OS can hand
 * the browser redirect back to the app.
 */
export const googleReversedClientScheme = (clientId: string) =>
  `com.googleusercontent.apps.${clientId.replace('.apps.googleusercontent.com', '')}`;
